<div class="egl-offline">
    <egl-icon class="egl-offline__icon" path="manutenzione" width="80" height="80"></egl-icon>
    <div class="egl-offline__paragraph-container">
        <p class="egl-offline__paragraph">{{ message }}</p>
    </div>
</div>
